<template>
  <div class='lead-form__cards-container'>
    <div class="lead-form__cards" v-for="(card, index) in cards" :key="index">
      <img
        :src="getIconCard(card.icon)"
        :alt="card.alt"
        :title="card.title"
        class="lead-form__cards-icon"
      >
      <h2 class="lead-form__cards-text" v-html="card.text"></h2>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cards: [
        {
          icon: 'iconcard-1',
          text: 'Gratuito <br> para usar',
          alt: 'Um caminhão na cor amarela',
          title: 'Caminhão'
        },
        {
          icon: 'iconcard-2',
          text: 'Use diversas <br> transportadoras',
          alt: 'Uma mão recebendo dois relógios na cor amarela',
          title: 'Recebendo relógios'
        },
        {
          icon: 'iconcard-3',
          text: 'Economize até <br> 80% nos fretes',
          alt: 'Uma mão entregando um papel com um X escrito em azul',
          title: 'Entregando papel'
        }

      ]
    }
  },
  methods: {
    getIconCard(icon) {
      return `../../../../images/registration/${icon}.svg`;
    }
  }
}
</script>
